import { Component  } from '@angular/core';
import { E5coreUiWorkFieldTypeInputBaseComponent } from './e5core-ui-work-field-type-input-base';

@Component({
  selector: 'e5core-ui-work-field-type-input-material',
  templateUrl: './e5core-ui-work-field-type-input-material.component.html',
  styleUrls: ['./e5core-ui-work-field-type-input-material.component.css']
})
export class E5coreUiWorkFieldTypeInputMaterialComponent extends E5coreUiWorkFieldTypeInputBaseComponent {
}
